export function Brand({ compact = false }: { compact?: boolean }) {
  return <div className="brand" aria-label="Finvia">
    <svg viewBox="0 0 64 64" aria-hidden="true"><path d="M18 12h34L44 23H28l-4 9h16L31 43H19l-4 10H4L18 12Z"/><path className="brand-mark-accent" d="m35 43 8-11h13L43 53H29l6-10Z"/></svg>
    {compact ? null : <span>Finvia</span>}
  </div>
}
